export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/my-details.e9c31775.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};